import Workspace, { WorkspaceDocument, WorkspaceFolder } from "./Workspace";

const flattenDocs = (workspace: Workspace): WorkspaceDocument[] => {
  const docs: WorkspaceDocument[] = [];

  // First we traverse all folders recursively to collect documents
  const traverse = (folder: WorkspaceFolder) => {
    docs.push(...folder.documents);
    folder.folders.forEach(traverse);
  };

  workspace.folders.forEach(traverse);
  docs.push(...workspace.documents);

  // Then we remove duplicates based on document ID
  const uniqueDocs = new Map<string, WorkspaceDocument>();
  docs.forEach((doc) => {
    if (!uniqueDocs.has(doc.id)) {
      uniqueDocs.set(doc.id, doc);
    }
  });
  return Array.from(uniqueDocs.values());
};

export { flattenDocs };
